/* eslint-disable react/require-default-props */
/* eslint-disable react/display-name */
import { styled } from '@material-ui/core';
import { cloneElement, forwardRef } from 'react';

type IconWrapperProps = {
  children: React.ReactElement<React.SVGProps<SVGSVGElement>>;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  fontSize?: string | number;
  color?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
};

const IconWrapper = forwardRef<HTMLDivElement, IconWrapperProps>(
  (
    {
      children,
      fontSize,
      color = 'inherit',
      style,
      disabled = false,
      ...props
    },
    ref
  ) => (
    <IconWrapperStyled
      ref={ref}
      style={{
        fontSize,
        lineHeight: 0,
        color: disabled || !color ? 'inherit' : color,
        ...(style || {}),
      }}
      {...props}
    >
      {cloneElement(children, {
        style: {
          color: disabled ? 'inherit' : color,
          ...(children.props.style || {}),
        },
        // width: fontSize,
        // height: fontSize,
      })}
    </IconWrapperStyled>
  )
);

const IconWrapperStyled = styled('div')({
  '& svg': { verticalAlign: '-0.125em', width: '1em', height: '1em' },
  '& svg *:not([fill="none"])': {
    fill: 'currentColor !important',
  },
});

export default IconWrapper;
